const deleteEquipmentServices = {
  toastr: 'Servicio Eliminado'
};

export default deleteEquipmentServices;
